import { faCircleSmall } from '@fortawesome/pro-solid-svg-icons';

import { MEMBERSHIP_ROLES } from 'src/features/userManagement/types';
import { userManagementMessages } from 'src/features/userManagement/utils/messages';
import { type BadgeOption, type BadgeOptions } from 'src/types/ui';

export const badgeRoleOptions: Record<MEMBERSHIP_ROLES, BadgeOption> = {
    [MEMBERSHIP_ROLES.OWNER]: {
        label: userManagementMessages.roleOwner,
        theme: 'sky',
    },
    [MEMBERSHIP_ROLES.OPERATOR]: {
        label: userManagementMessages.roleOperator,
        theme: 'emerald',
    },
    [MEMBERSHIP_ROLES.VIEWER]: {
        label: userManagementMessages.roleViewer,
        theme: 'indigo',
    },
    [MEMBERSHIP_ROLES.CLIENT]: {
        label: userManagementMessages.roleClient,
        theme: 'purple',
    },
    [MEMBERSHIP_ROLES.VALIDATOR]: {
        label: userManagementMessages.roleValidator,
        theme: 'yellow',
    },
    [MEMBERSHIP_ROLES.FINANCE]: {
        label: userManagementMessages.roleFinance,
        theme: 'orange',
    },
    [MEMBERSHIP_ROLES.PARKING_MANAGER]: {
        label: userManagementMessages.roleParkingManager,
        theme: 'sky',
    },
    [MEMBERSHIP_ROLES.RECEPTION]: {
        label: userManagementMessages.roleReception,
        theme: 'sky',
    },
    [MEMBERSHIP_ROLES.SALES_MANAGER]: {
        label: userManagementMessages.roleSalesManager,
        theme: 'sky',
    },
    [MEMBERSHIP_ROLES.RECEPTION_MANAGER]: {
        label: userManagementMessages.roleReceptionManager,
        theme: 'sky',
    },
};

export const statusOptions: BadgeOptions = {
    active: {
        label: userManagementMessages.statusActive,
        icon: faCircleSmall,
        color: { iconColor: '#22c55e' },
    },
    inactive: {
        label: userManagementMessages.statusInactive,
        icon: faCircleSmall,
        color: { iconColor: '#ef4444' },
    },
};

export const membershipRoleOptions = [
    { label: userManagementMessages.roleOwner, value: MEMBERSHIP_ROLES.OWNER },
    { label: userManagementMessages.roleOperator, value: MEMBERSHIP_ROLES.OPERATOR },
    { label: userManagementMessages.roleViewer, value: MEMBERSHIP_ROLES.VIEWER },
    { label: userManagementMessages.roleClient, value: MEMBERSHIP_ROLES.CLIENT },
    { label: userManagementMessages.roleValidator, value: MEMBERSHIP_ROLES.VALIDATOR },
    { label: userManagementMessages.roleFinance, value: MEMBERSHIP_ROLES.FINANCE },
    { label: userManagementMessages.roleParkingManager, value: MEMBERSHIP_ROLES.PARKING_MANAGER },
    { label: userManagementMessages.roleReception, value: MEMBERSHIP_ROLES.RECEPTION },
    { label: userManagementMessages.roleSalesManager, value: MEMBERSHIP_ROLES.SALES_MANAGER },
    { label: userManagementMessages.roleReceptionManager, value: MEMBERSHIP_ROLES.RECEPTION_MANAGER },
];
